module.exports = __webpack_public_path__ + "img/RE.0017878b.png";